import { Truncate } from '@labrav/react-components'
import React from 'react'

export type ViewValueWithTruncateProps = {
  value?: string
  showIcon?: boolean
  width?: string
}

export const ViewValueWithTruncate = ({
  value,
  showIcon = false,
  width = '90%',
}: ViewValueWithTruncateProps) => {
  if (!value) return '-'

  return (
    <Truncate width={width} clipboardTooltip showIcon={showIcon}>
      {value}
    </Truncate>
  )
}
